import { TranslationProvider } from "@mittwald/flow-components/dist/components/TranslationProvider";
import mStudioImage from "./img/mstudio.png";
import { Box } from "@mittwald/flow-components/dist/components/Box";
import { ContentBox } from "@mittwald/flow-components/dist/components/ContentBox";
import { H1 } from "@mittwald/flow-components/dist/components/H1";
import { Image } from "@mittwald/flow-components/dist/components/Image";
import { Text } from "@mittwald/flow-components/dist/components/Text";
import { TextLink } from "@mittwald/flow-components/dist/components/TextLink";
import type { FC } from "react";
import React from "react";
import Customer from "../../../model/customer/Customer";

export const OrderComplete: FC<{ customerId: string }> = (props) => {
  const { customerId } = props;

  const customer = Customer.useLoadById(customerId);
  const email = customer.contact?.data.emailAddress;

  return (
    <TranslationProvider name="orderCompleted" type="component">
      <ContentBox>
        <Box _alignItems="center" _flexDirection="column">
          <Box
            _alignItems="center"
            _flexDirection="column"
            _itemGap="m"
            _maxW={430}
          >
            <Image _height="auto" _width={230} url={mStudioImage} />
            <H1 i18n="orderCompleteHeadline" />
            <Text
              center
              i18n={
                email
                  ? { id: "orderCompleteText", values: { email } }
                  : "orderCompleteWithoutEmailText"
              }
            />
            <TextLink
              action="https://studio.mittwald.de/login"
              i18n="mStudioLink"
            />
          </Box>
        </Box>
      </ContentBox>
    </TranslationProvider>
  );
};

export default OrderComplete;
